import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.PERMISSIONS

export function updatePermList(data) {
    return apiHelper({ method: "post", path: pathBase.UPDATE, data })
}

export function getPermList() {
    return apiHelper({ method: "get", path: pathBase.GET })
}
